import { getUser, setOnboardingViewedStatus } from "api";

import Backdrop from "components/global/Backdrop";
import Spacer from "components/global/Spacer";
import accountNavigation from "assets/images/onboarding/accountNavigation.png";
import addingSocials from "assets/images/onboarding/addingSocials.png";
import { connect } from "react-redux";
import creatingBrandAccounts from "assets/images/onboarding/creatingClientAccounts.png";
import creatingDrafts from "assets/images/onboarding/creatingDrafts.png";
import creatingPosts from "assets/images/onboarding/creatingPosts.png";
import draftComments from "assets/images/onboarding/draftComments.png";
import invitingTeamMembers from "assets/images/onboarding/invitingTeamMembers.png";
import styled from "styled-components";
import switchingUsers from "assets/images/onboarding/switchingUsers.png";
import { useState } from "react";
import welcome from "assets/images/onboarding/welcome.png";

const Wrapper = styled(Backdrop)`
  z-index: 50;
  opacity: 1;
  pointer-events: all;

  .close {
    position: absolute;
    top: 24px;
    right: 30px;
    cursor: pointer;
  }

  .card {
    width: 40rem;
    min-height: 40.8rem;
    background-color: var(--white);
    background: linear-gradient(
      180deg,
      #3badff 0%,
      #66afff 6.5%,
      #84b2ff 12.5%,
      #9cb4ff 20.22%,
      #b0b7ff 29.53%,
      #ffffff 56.62%
    );
    border-radius: 1.6rem;
  }

  .cardContent {
    padding: 3.6rem;
  }

  .imageWrapper {
    min-height: 20rem;
    position: relative;
  }

  .btn {
    height: 4.8rem;
    width: calc(50% - 1.2rem);
    border-radius: 0.8rem;
    padding: 0 2.4rem;
    text-transform: capitalize;

    &.cancel {
      background-color: var(--white);
      color: var(--secondary);
      border: 1px solid var(--secondary);
    }

    &.actionBtn {
      background-color: var(--primary);
      color: var(--white);
    }

    &:disabled {
      background-color: var(--body_text);
    }
  }

  @media screen and (max-width: 768px) {
    .card {
      width: calc(100% - 4.8rem);
      padding: 4.8rem 2.4rem;

      .title {
        font-size: 16px;
        line-height: 20px;
      }

      .description {
        font-size: 14px;
        line-height: 20px;
      }

      .btn {
        min-width: unset;
        width: calc(50% - 1.2rem);
      }
    }
  }
`;

const allContent = [
  {
    accountType: "personal",
    image: addingSocials,
    title: "Adding social media accounts",
    description:
      "To begin scheduling and posting on multiple platforms, connect any of these social media accounts to PostPaddy.",
    imageStyle: {},
  },
  {
    accountType: "business",
    image: creatingBrandAccounts,
    title: "Creating client accounts",
    description:
      "Create an account for each client, add their social media handles and publish to them simultaneously from PostPaddy.",
    imageStyle: { position: "absolute", bottom: "-20px", right: 0 },
  },
  {
    accountType: "business",
    image: invitingTeamMembers,
    title: "Inviting team members",
    description:
      "Invite team members to co-manage your business account, create and schedule posts with PostPaddy.",
    imageStyle: { marginBottom: "-36px" },
  },
  {
    accountType: "both",
    image: creatingPosts,
    title: "Creating posts",
    description:
      "Create and preview posts, publish instantly or schedule for later all from one dashboard.",
    imageStyle: { marginBottom: "-84px" },
  },
  {
    accountType: "both",
    image: creatingDrafts,
    title: "Creating drafts",
    description:
      "Save great content ideas for later, refine and publish when it’s good to go!",
    imageStyle: { marginBottom: "-84px" },
  },
  {
    accountType: "business",
    image: draftComments,
    title: "Draft comments",
    description:
      "Collaborate with your team to create high-quality content. Leave comments on drafts to receive feedback and refine content as a team.",
    imageStyle: { marginBottom: "-84px" },
  },
  {
    accountType: "both",
    image: accountNavigation,
    title: "Account navigation",
    description:
      "Personal account users can add a business account using the “+” button. Switch between multiple accounts with ease from the side bar.",
    imageStyle: {},
  },
  {
    accountType: "both",
    image: switchingUsers,
    title: "Switching users",
    description:
      "It’s easy to add and switch between additional PostPaddy user accounts from your profile on the dashboard.",
    imageStyle: { marginBottom: "-36px" },
  },
  {
    accountType: "",
    image: "",
    title: "",
    description: "",
    imageStyle: {},
  },
  {
    accountType: "",
    image: "",
    title: "",
    description: "",
    imageStyle: {},
  },
];

const Onboarding = ({ hide, setHide, active_account }) => {
  const [step, setStep] = useState(0);

  const handleClose = async () => {
    setHide(true);
    await setOnboardingViewedStatus();
  };

  const handleNext = () => {
    setStep((prev) => prev + 1);
  };

  const handleStart = async () => {
    setStep((prev) => prev + 1);
    await setOnboardingViewedStatus();
    await getUser();
  }

  if (hide || !active_account) return null;

  return (
    <Wrapper className="flexRow alignCenter justifyCenter">
      {step === 0 ? (
        <div className="card flexColumn alignCenter">
          <div className="flexRow alignCenter justifyCenter fullWidth imageWrapper">
            {/* close */}
            <svg
              className="close"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              onClick={handleClose}
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.29279 4.29259C4.48031 4.10512 4.73462 3.99981 4.99979 3.99981C5.26495 3.99981 5.51926 4.10512 5.70679 4.29259L9.99979 8.58559L14.2928 4.29259C14.385 4.19708 14.4954 4.1209 14.6174 4.06849C14.7394 4.01608 14.8706 3.9885 15.0034 3.98734C15.1362 3.98619 15.2678 4.01149 15.3907 4.06177C15.5136 4.11205 15.6253 4.18631 15.7192 4.2802C15.8131 4.37409 15.8873 4.48574 15.9376 4.60864C15.9879 4.73154 16.0132 4.86321 16.012 4.99599C16.0109 5.12877 15.9833 5.25999 15.9309 5.382C15.8785 5.504 15.8023 5.61435 15.7068 5.70659L11.4138 9.99959L15.7068 14.2926C15.8889 14.4812 15.9897 14.7338 15.9875 14.996C15.9852 15.2582 15.88 15.509 15.6946 15.6944C15.5092 15.8798 15.2584 15.985 14.9962 15.9873C14.734 15.9895 14.4814 15.8888 14.2928 15.7066L9.99979 11.4136L5.70679 15.7066C5.51818 15.8888 5.26558 15.9895 5.00339 15.9873C4.74119 15.985 4.49038 15.8798 4.30497 15.6944C4.11956 15.509 4.01439 15.2582 4.01211 14.996C4.00983 14.7338 4.11063 14.4812 4.29279 14.2926L8.58579 9.99959L4.29279 5.70659C4.10532 5.51907 4 5.26476 4 4.99959C4 4.73443 4.10532 4.48012 4.29279 4.29259Z"
                fill="white"
              />
            </svg>

            <img
              src={welcome}
              alt="."
              className="image"
              style={{ position: "absolute", bottom: 0, right: 0 }}
            />
          </div>
          <div className="cardContent">
            <Spacer y={1.2} />
            <h5 className="colorGrey1 textCenter title">
              Welcome to PostPaddy
            </h5>
            <Spacer y={0.4} />
            <p className="body-3 colorBodyText textCenter description">
              We’re glad to have you onboard. Take a quick tour to learn how to
              use PostPaddy
            </p>
            <Spacer y={2.4} />
            <div className="flexRow justifyCenter fullWidth">
              <button
                className="btn cancel flexRow alignCenter justifyCenter"
                onClick={handleClose}
              >
                No thanks
              </button>
              <Spacer x={2.4} />
              <button
                onClick={handleStart}
                className="btn actionBtn flexRow alignCenter justifyCenter"
              >
                Get started
              </button>
            </div>
          </div>
        </div>
      ) : (
        allContent
          .filter((content) =>
            [active_account.type, "both"].includes(content.accountType)
          )
          .map((content, index) => (
            <div
              key={index}
              className={`card flexColumn alignCenter${
                step === index + 1 ? "" : " hidden"
              }`}
            >
              <div className="flexRow alignCenter justifyCenter fullWidth imageWrapper">
                {/* Close */}
                <svg
                  className="close"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  onClick={handleClose}
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.29279 4.29259C4.48031 4.10512 4.73462 3.99981 4.99979 3.99981C5.26495 3.99981 5.51926 4.10512 5.70679 4.29259L9.99979 8.58559L14.2928 4.29259C14.385 4.19708 14.4954 4.1209 14.6174 4.06849C14.7394 4.01608 14.8706 3.9885 15.0034 3.98734C15.1362 3.98619 15.2678 4.01149 15.3907 4.06177C15.5136 4.11205 15.6253 4.18631 15.7192 4.2802C15.8131 4.37409 15.8873 4.48574 15.9376 4.60864C15.9879 4.73154 16.0132 4.86321 16.012 4.99599C16.0109 5.12877 15.9833 5.25999 15.9309 5.382C15.8785 5.504 15.8023 5.61435 15.7068 5.70659L11.4138 9.99959L15.7068 14.2926C15.8889 14.4812 15.9897 14.7338 15.9875 14.996C15.9852 15.2582 15.88 15.509 15.6946 15.6944C15.5092 15.8798 15.2584 15.985 14.9962 15.9873C14.734 15.9895 14.4814 15.8888 14.2928 15.7066L9.99979 11.4136L5.70679 15.7066C5.51818 15.8888 5.26558 15.9895 5.00339 15.9873C4.74119 15.985 4.49038 15.8798 4.30497 15.6944C4.11956 15.509 4.01439 15.2582 4.01211 14.996C4.00983 14.7338 4.11063 14.4812 4.29279 14.2926L8.58579 9.99959L4.29279 5.70659C4.10532 5.51907 4 5.26476 4 4.99959C4 4.73443 4.10532 4.48012 4.29279 4.29259Z"
                    fill="white"
                  />
                </svg>

                <img
                  src={content.image}
                  alt="."
                  className="image"
                  style={content.imageStyle}
                />
              </div>
              <div className="cardContent">
                <Spacer y={1.2} />
                <h5 className="colorGrey1 textCenter title">{content.title}</h5>
                <Spacer y={0.4} />
                <p className="body-3 colorBodyText textCenter description">
                  {content.description}
                </p>
                <Spacer y={2.4} />
                <div className="flexRow alignCenter justifySpaceBetween fullWidth">
                  <span className="body-2 colorBodyText">
                    {index + 1} of {active_account.type === "business" ? 7 : 5}
                  </span>
                  <Spacer x={2.4} />
                  <button
                    onClick={
                      (active_account.type === "business" ? 7 : 5) === step
                        ? handleClose
                        : handleNext
                    }
                    className="btn actionBtn flexRow alignCenter justifyCenter"
                  >
                    {(active_account.type === "business" ? 7 : 5) === step
                      ? "Done"
                      : "Next"}
                  </button>
                </div>
              </div>
            </div>
          ))
      )}
    </Wrapper>
  );
};

const mapStateToProps = (state) => {
  return {
    active_account: state.active_account,
  };
};

export default connect(mapStateToProps)(Onboarding);
